import { createContext } from "react"
import type { IndoorMapContextType } from "./types"

export const IndoorMapContext = createContext<IndoorMapContextType | null>(null)
